export default __webpack_public_path__ + "static/media/ultimo-palhaco.b01886a6.png";